export default __webpack_public_path__ + "static/illustration-business.url-19b9709d7e7ab7482a728c6b6e95c051.svg";